import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = () => {
  const isLogin = Boolean(localStorage.getItem('isLogin'));
  const userRole = localStorage.getItem('UserRole');
  const location = useLocation();

  if (!isLogin) {
    return <Navigate to="/" />;
  }

  if (userRole === '1') {
    const restrictedUserPaths = ['/main/reports', '/main/zones', '/main/trips', '/main/home', '/main/report-pdf'];
    if (restrictedUserPaths.includes(location.pathname)) {
      return <Navigate to="/main/subscription" />;
    }
  } else if (userRole === '2') {
    const restrictedAdminPaths = ['/main/subscription', '/main/user', '/main/health'];
    if (restrictedAdminPaths.includes(location.pathname)) {
      return <Navigate to="/main/home" />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
